import { useState } from 'react'
// import React from "react";
import './FlipCard.scss'
const FlipCard = ({ frontContent, backContent }) => {
  const [isFlipped, setIsFlipped] = useState(false)
  return (
    // give .flip-card height and width
    <div className='flip-card'>
      <div
        className={`flip-card-inner ${isFlipped ? 'flipped' : ''}`}
        onClick={() => setIsFlipped(!isFlipped)}
      >
        {/* give .front and .back styling */}
        {frontContent}
        {backContent}
      </div>
    </div>
  )
}
export default FlipCard
